import { Box, Modal, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";
import {
  ExpandableEvidenceView,
  ModalResizeHandle,
  useResizing,
} from "./MisconfigurationEvidenceUtils";

const MisconfigurationEvidenceModal = ({
  controlId,
  evidence,
  handleClose,
}) => {
  const colors = useColors();
  const {
    dimensions: modalSize,
    handleMouseDown,
    handleMouseMove,
    handleMouseUp,
    isResizing,
  } = useResizing({ width: 600, height: 700 });

  return (
    <Modal
      open={true}
      onClose={handleClose}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: modalSize.width,
          height: modalSize.height,
          bgcolor: colors.common_white,
          borderRadius: 2,
          p: 3,
          display: "flex",
          flexDirection: "column",
          transition: isResizing.active ? "none" : "width 0.1s, height 0.1s",
          overflow: "hidden",
          border: `1px solid ${colors.divider2}`,
          boxShadow: `0 8px 32px ${colors.common_black}20`,
          "&:hover .modal-resize-hint": {
            opacity: 1,
          },
        }}
      >
        {/* Header with resize hint */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            pb: 1,
            borderBottom: `1px solid ${colors.divider2}`,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Evidence Details
          </Typography>
          <Typography
            className="modal-resize-hint"
            sx={{
              fontSize: "12px",
              color: colors.grey_500,
              opacity: 0.7,
              transition: "opacity 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            ⋱ Drag corner to resize
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            position: "relative",
            height: "100%",
            overflow: "auto",
          }}
        >
          <ExpandableEvidenceView evidence={evidence} controlId={controlId} />

          <ModalResizeHandle
            type="both"
            position={{
              right: 8,
              bottom: 8,
            }}
            onMouseDown={handleMouseDown}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default MisconfigurationEvidenceModal;
